import { render, staticRenderFns } from "./veJkyFundClaimShen.vue?vue&type=template&id=5c6a1aa5&scoped=true"
import script from "./veJkyFundClaimShen.vue?vue&type=script&lang=js"
export * from "./veJkyFundClaimShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a1aa5",
  null
  
)

export default component.exports